import * as React from 'react'
import { CustomSettingsCard } from '@user/components/Settings/EntityFormSettings/CustomSettings/CustomSettingCard'
import type { ICustomFieldFormSetting } from '@user/store/entityFormSettings'
import type { ENTITY_TYPES } from '@sales-center/common'
import { useMemo } from 'react'

type Props = {
  settings: ICustomFieldFormSetting[]
  entityType: ENTITY_TYPES
  isTidalThemeActive: boolean
}

const positionInList = (index, settings) =>
  index === 0 ? 'first' : index === settings.length - 1 ? 'last' : 'common'

export function CustomSettingsCards(props: Props) {
  const { settings, entityType, isTidalThemeActive } = props

  const cards = useMemo(
    () =>
      settings.map((setting, index) => (
        <CustomSettingsCard
          key={`custom_card_${index}`}
          settingItem={setting}
          customSettings={settings}
          entityType={entityType}
          position={positionInList(index, settings)}
          isTidalThemeActive={isTidalThemeActive}
        ></CustomSettingsCard>
      )),
    [settings, entityType, isTidalThemeActive],
  )

  return <>{cards}</>
}
